<img class="spinner" src="../../../../assets/img/spinner/gradientSpiral.svg">
<img class="logo" src="../../../../assets/img/spinner/{{logo}}.svg">